//constants
import { GET_ACCESS_TOKEN_ACTION, CLEAN_USER_ACCESS_TOKEN_DATA } from "./Constants";

const INITIAL_STATE = {
  userAccessTokenInfo: {
    userId: "",
    accessToken: "",
    userData: {},
  },
};
export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_ACCESS_TOKEN_ACTION:
      return {
        ...state,
        userAccessTokenInfo: {
          ...state.userAccessTokenInfo,
          userId: action.response.user_id ? action.response.user_id : "",
          accessToken: action.response.access_token
            ? action.response.access_token
            : "",
          userData: action.response.user_data ? action.response.user_data : "",
        },
      };
    case CLEAN_USER_ACCESS_TOKEN_DATA:
      return {
        ...state,
        userAccessTokenInfo: {
          ...state.userAccessTokenInfo,
          userId : "",
          accessToken : "",
          userData: "",
        }
      }
    default:
      return state;
  }
}
